/* eslint-disable */
import {
  Flex,
  Icon,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Input,
  Button,
  Select,
  HStack,
  Box
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card";
import React, { useState, useEffect, useMemo } from "react";
import { usePagination, useSortBy, useTable, useFilters } from "react-table";
import moment from "moment";
import { downloadExcel } from "react-export-table-to-excel";
import { convertDateToLocal } from "../../../../utils/Utils";
import { getAnalyticsCallUnansweredApi} from "../../../../redux/agent";
import { MdPlayArrow, MdDownload } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import { setLoader } from "../../../../redux/actions/loader";
import axios from "axios"
export default function UnAnswereAnalyticsTable(props) {
  const { title, columnsData, tableData } = props;
  const dispatch = useDispatch();
  const columns = useMemo(() => columnsData, [columnsData]);
  const userData = useSelector((state) => state.userData);
  const [unansweredDataList,setUnansweredDataList] = useState([])
  const [unansweredResponseData,setUnansweredResponseData] = useState(null)
  // const data = useMemo(() => tableData, [tableData]);
  const [data, setData] = useState([]);
  useEffect(() => {
    const modifiedDataArray = tableData?.results?.map((dataObject) => {
      let myDate = convertDateToLocal(dataObject.response_time);

      let modifiedData = {
        phoneNumber: maskPhoneNo(dataObject.userId),
        sessionId: dataObject.sessionId,
        // personName: dataObject.userDetails?.userFullName,
        // productName:dataObject.userDetails?.productName,
        // bankName:dataObject.userDetails?.bankName,
        // agentName:dataObject.userDetails?.agentName,
        // language: dataObject.userDetails?.language,
        numberOfAttempts: dataObject.numberOfAttempts,
        callStatus: dataObject.call_state,
        timestamp: myDate,
      };
      return modifiedData;
    });
    setData(modifiedDataArray);
  }, [tableData]);

    const maskPhoneNo = (number)=>{
    if(number){
      let noString = number.toString()
      let newNo = "XXXX"+noString.substring(4,noString.length)
      return newNo
    }
    else {
      return ""
    }
  }

  function DefaultColumnFilter({ column: { filterValue, setFilter } }) {
    return (
      <span>
        <Input
          variant="filled"
          size="sm"
          value={filterValue || ""}
          onChange={(e) => {
            setFilter(e.target.value || undefined);
            console.log("Column : ", setFilter);
            console.log("Change ", e.target.value);
          }}
          placeholder={"Filter"}
          htmlSize={4}
          width="auto"
        />
      </span>
    );
  }

  const getCallStatus = (callStatus) => {
    return callStatus;
    switch (callStatus) {
      case "switchoff":
        return "Switch off";
      case "called_party":
        return "Not received";
      case "DC":
        return "Declined";
      case "busy":
        return "Busy";

      default:
        return "NA";
    }
  };
  async function handleDownloadExcel() {
    window.__downloadTriggered = false
    dispatch(setLoader(true))
    const headersArray = columnsData.map((column) => {
      return column.Header;
    });


    const payload = {
      selectedDateRange: props.selectedDateRange,
      clientName: "NICL",
      scenarioID: props.scenarioId,
      token: userData.token,
      limit: 500,
      page: 1,
      // ...props?.unansweredFilter,
    }
    let genData = []
    const unansweredDataRes = await getAnalyticsCallUnansweredApi(payload)
    let pagesCount =  Math.round(Number(unansweredDataRes.data.totalCount)/500) + 1

    genData = [...unansweredDataRes.data.results]
    setUnansweredResponseData(unansweredDataRes.data)
    async function fetchAndProcessData (payload){
      const unansweredDataRes = await getAnalyticsCallUnansweredApi(payload)
      genData= [...genData,...unansweredDataRes.data.results]
      setUnansweredDataList(genData)

    }
    for(let i=2;i<=pagesCount;i++){
      setTimeout(()=>{
        let Payload = {
          selectedDateRange: props.selectedDateRange,
          clientName: "NICL",
          scenarioID: props.scenarioId,
          token: userData.token,
          limit: 500,
          page: i,
        }
        fetchAndProcessData(Payload)
        console.log("Proceeseed iter ",i)
        // console.log("Data List",genData)
      },1000*i)


    }
    // console.log("Unansewered res",unansweredDataRes)
  }

  function downloadExcelFile(){

    const headersArray = columnsData.map((column) => {
      return column.Header;
    });
    let modifiedDataArray = unansweredDataList.map((dataObject) => {
      let myDate = convertDateToLocal(dataObject.response_time);
      let modifiedData = {
        phoneNumber: dataObject.userId,
        sessionId: `'${dataObject?.sessionId.toString()}`,
        numberOfAttempts: dataObject&&dataObject.numberOfAttempts?dataObject.numberOfAttempts:0,
        callStatus: dataObject.call_state,
        timestamp: myDate,
      };
      return modifiedData;
    });
    console.log("modified data array",modifiedDataArray)

    // console.log("modified data array",modifiedDataArray)
   if(modifiedDataArray?.length){
    downloadExcel({
      fileName: title.replaceAll(" ", ""),
      sheet: title.replaceAll(" ", ""),
      tablePayload: {
        header: headersArray,
        body: modifiedDataArray,
      },
    });
   }
  }

  useEffect(()=>{

    if(unansweredResponseData&&unansweredResponseData.totalCount===unansweredDataList.length){
     if (!window.__downloadTriggered) {
      window.__downloadTriggered = true
      console.log("Reached End")
      downloadExcelFile()
      dispatch(setLoader(false))
    }
    }

  },[unansweredDataList])

  console.log("Unanswered Data====",unansweredDataList)

  const tableInstance = useTable(
    {
      columns,
      data,
      // defaultColumn: { Filter: DefaultColumnFilter },
    },
    useFilters,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
    initialState,
    preGlobalFilteredRows,
    setGlobalFilter,
    //
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = tableInstance;
  initialState.pageSize = 11;

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const iconColor = useColorModeValue("#2185d0");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [audioUrl, setAudioUrl] = useState("");
  const [custFilterValue, setCustFilterValue] = useState({});

  return (
    <Card direction="column" mh="400px" w="100%" px="0px">
      <Flex px="25px" justify="space-between" mb="15px" align="center">
        <Text
          color={textColor}
          fontSize="15px"
          fontWeight="700"
          lineHeight="100%"
        >
          {title}
        </Text>
        <Box className="headRight">
        <Box className="filterButton">
        <Button
          size="sm"

          colorScheme={props.unansweredFilter.isfilter?"blue":"black"}
          // leftIcon={<MdDownload />}
          onClick={() => {
            props.applyFilteUnansweredData();
          }}
        >
          Apply Filter
        </Button>
        <Button
          size="sm"
          colorScheme="red"

          // leftIcon={<MdDownload />}
          onClick={() => {
            setCustFilterValue({});
            props.discardFilterUnansweredData();
          }}
        >
          Clear
        </Button>
        </Box>
        <Button
          size="sm"
          colorScheme="blue"
          leftIcon={<MdDownload />}
          onClick={() => {
            handleDownloadExcel();
          }}
        >
          Export
        </Button>
        </Box>
      </Flex>
      <div className="analyticsTable unAnsTable">
        <Table
          {...getTableProps()}
          m="15px auto"
          size="sm"
          variant="striped"
          colorScheme="blackAlpha"
          display="block"
        >
          <Thead>
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => {
                  return (
                    <Th
                      // {...column.getHeaderProps(column.getSortByToggleProps())}
                      pe="10px"
                      key={index}
                      borderColor={borderColor}
                    >
                      <Flex
                        justify="space-between"
                        align="center"
                        fontSize="12px"
                        color="gray.400"
                      >
                        {column.render("Header")}
                      </Flex>
                      <span>
                        {column.canFilter ? (
                          <Input
                            variant="filled"
                            size="sm"
                            value={custFilterValue[column.id]&&custFilterValue[column.id].length>0?custFilterValue[column.id]:""}
                            onChange={(e) => {
                              if (column.id === "phoneNumber") {
                                props.setUnansweredFilter({
                                  ...props.unansweredFilter,
                                  phoneNumber: e.target.value,
                                  isfilter:e.target.value.length===0?false:true
                                });
                              }
                              if (column.id === "sessionId") {
                                props.setUnansweredFilter({
                                  ...props.unansweredFilter,
                                  sessionId: e.target.value,
                                  isfilter:e.target.value.length===0?false:true
                                });
                              }

                              let tempCustFilterRef = Object.assign(
                                {},
                                custFilterValue
                              );
                              if (
                                tempCustFilterRef[column.id] &&
                                e.target.value.length === 0
                              ) {
                                delete tempCustFilterRef[column.id];
                              } else {
                                tempCustFilterRef[column.id] = e.target.value;
                              }
                              setCustFilterValue(tempCustFilterRef);
                            }}
                            placeholder={"Filter"}
                            htmlSize={4}
                            width="auto"
                          />
                        ) : null}
                      </span>
                    </Th>
                  );
                })}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()} overflow="auto">
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <Tr {...row.getRowProps()} key={index}>
                  {row.cells.map((cell, index) => {
                    let data = "";
                    if (cell.column.Header === "Call Recording") {
                      data = (
                        <Flex align="center">
                          <Icon
                            w="24px"
                            h="24px"
                            me="5px"
                            _hover={{ cursor: "pointer" }}
                            _focus={{ boxShadow: "outline" }}
                            as={MdPlayArrow}
                            color={iconColor}
                            onClick={() => {
                              setAudioUrl(cell.value);
                              onOpen();
                            }}
                          />
                        </Flex>
                      );
                    } else {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    }
                    return (
                      <Td
                        {...cell.getCellProps()}
                        key={index}
                        fontSize={{ sm: "14px" }}
                        minW={{ sm: "150px", md: "200px", lg: "auto" }}
                        borderColor="transparent"
                      >
                        {data}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </div>
      <div className="pagination" style={{ margin: "25px 30px 0px 25px" }}>
        <HStack className="bottomPagination">
          <div className="pageChangeBtn">
            <Button
              size="sm"
              onClick={() => {
                props.setUnansweredsTablePageNo(1);
              }}
              disabled={!canPreviousPage}
            >
              {"<<"}
            </Button>{" "}
            <Button
              size="sm"
              onClick={() =>
                props.setUnansweredsTablePageNo(props.unansweredTablePageNo - 1)
              }
              disabled={!canPreviousPage}
            >
              {"<"}
            </Button>{" "}
            <Button
              size="sm"
              onClick={() =>
                props.setUnansweredsTablePageNo(props.unansweredTablePageNo + 1)
              }
              disabled={!canNextPage}
            >
              {">"}
            </Button>{" "}
            <Button
              size="sm"
              onClick={() =>
                props.setUnansweredsTablePageNo(
                  Math.round(
                    tableData.totalCount / props.pageLimitUnansweredTable
                  )
                )
              }
              disabled={!canNextPage}
            >
              {">>"}
            </Button>{" "}
          </div>
          <div className="pageCounter">
            <Text fontSize="sm">
              Page{" "}
              <strong>
                {props.unansweredTablePageNo} of
                {Math.round(
                  tableData.totalCount / props.pageLimitUnansweredTable
                )}
              </strong>{" "}
            </Text>
            <span>|</span>
            <Text fontSize="sm">
              Go to page:{" "}
              <Input
                type="number"
                defaultValue={pageIndex + 1}
                onChange={(e) => {
                  const page = e.target.value ? Number(e.target.value) - 1 : 0;
                  props.setUnansweredsTablePageNo(page);
                }}
                variant="filled"
                size="xs"
                width="20%"
              />
            </Text>
            <Select
              value={pageSize}
              onChange={(e) => {
                props.setLimitUnansweredTable(Number(e.target.value));
                setPageSize(Number(e.target.value));
              }}
              variant="filled"
              size={"xs"}
              width={"auto"}
            >
              {[10, 50, 100].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </Select>
          </div>
        </HStack>
      </div>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Call Recording</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <figure style={{ margin: "10px auto" }}>
              <audio controls autoPlay style={{ width: "100%" }} src={audioUrl}>
                {/* <a href="/media/cc0-audio/t-rex-roar.mp3">Download audio</a> */}
              </audio>
            </figure>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Card>
  );
}
